import { path } from 'ramda';

import { ENTITIES_STORE_KEY } from '@/redux/constants';

export const getDaoRoot = path([ENTITIES_STORE_KEY, 'usersStatistics', 'dao']);
